<template>
    <keep-alive>
        <router-view/>
    </keep-alive>
</template>

<script>
    export default {
        name: "Pre_Creator_Events"
    }
</script>

<style scoped>

</style>